import React, { useEffect } from 'react';
import FiyatTablosu from '../components/fiyat_tablo';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/TvPage.css';

const TvPage = () => {
  const { isDarkMode } = useTheme();

  useEffect(() => {
    return () => {
      if (document.fullscreenElement) {
        document.exitFullscreen().catch(() => {});
      }
    };
  }, []);

  return (    <div className={`tv-page ${isDarkMode ? 'dark-mode' : ''}`}>
      <section className="tv-info-banner">
        <span>Fiyatlarımız bilgi amaçlıdır.</span>
      </section>
      <FiyatTablosu tvMode />
    </div>
  );
};

export default TvPage;
